import { useQuery } from "@tanstack/react-query";
import momentsClient from "../../../../api/moments";

export const MOMENT_OCCASIONS_QUERY_KEY = ["moment-occasions"];

const useMomentOccasionsQuery = () =>
  useQuery({
    queryKey: MOMENT_OCCASIONS_QUERY_KEY,
    queryFn: () => momentsClient.getOccasions(),
  });

export default useMomentOccasionsQuery;
